import {createContext, useState} from "react";

const ModalContext = createContext();

export function ModalProvider({children}) {
    const [basicModalIsOpen, setBasicModalIsOpen] = useState(false);
    const [failedSalesForceModalIsOpen, setFailedSalesForceModalIsOpen] = useState(false);
    const [deleteEnvModalIsOpen, setDeleteEnvModalIsOpen] = useState(false);
    const [envUrl, setEnvUrl] = useState("");
    const [isInvitation, setIsInvitation] = useState(false);
    const [deleted, setDeleted] = useState(false);
    const [contentMessage, setContentMessage] = useState("");
    const [isEnvActive, setIsEnvActive] = useState(false);
    const [threatGuardModalIsOpen, setThreatGuardModalIsOpen] = useState(false);
    return (
        <ModalContext.Provider value={{
            basicModalIsOpen,
            setBasicModalIsOpen,
            failedSalesForceModalIsOpen,
            setFailedSalesForceModalIsOpen,
            envUrl,
            setEnvUrl,
            contentMessage,
            setContentMessage,
            isInvitation,
            setIsInvitation,
            deleteEnvModalIsOpen,
            setDeleteEnvModalIsOpen,
            deleted,
            setDeleted,
            isEnvActive,
            setIsEnvActive,
            threatGuardModalIsOpen,
            setThreatGuardModalIsOpen
        }}>{children}</ModalContext.Provider>
    );
}

export default ModalContext;
